import Clients from "../../../api/clients";
import { toast } from "react-toastify";

export const clients = {
  state: {
    clients: [],
    clientsForSelector: [],
  },
  reducers: {
    setClients(state, payload) {
      return {
        ...state,
        clients: payload,
      };
    },
    setClientsForSelector(state, clientsForSelector) {
      return {
        ...state,
        clientsForSelector
      }
    }
  },
  effects: (dispatch) => ({
    async loadClientsAsync() {
      try {
        const { data } = await Clients.getUserClients();
        this.setClients(data);
      } catch (error) {
        return null;
      }
    },
    async loadClientsByNicknameAsync(nickname, rootState) {
      try {
        const { data } = await Clients.getByNickname(nickname);
        return data;
      } catch(error) {
        return toast.error(`Erro ao carregar clientes com o apelido ${nickname}`);
      }
    },
    async loadClientsByDocumentAsync(documentNumber, rootState) {
      try {
        const document = documentNumber.replace(/\D/g, '');
        const { data } = await Clients.searchByDocument(document);
        return data;
      } catch(error) {
        return toast.error(`Erro ao carregar clientes com o documento ${documentNumber}`);
      }
    }
  }),
};
